import { StyleSheet } from "react-native";
import { THEME_COLORS } from "../../../theme/constants/themeColors";
import { THEME_STYLES } from "../../../theme/constants/themeStyles";

export default StyleSheet.create({
	container: {
		borderRadius: THEME_STYLES.buttonStyle.borderRadius,
		justifyContent: "center",
		alignItems: "center",
		flexDirection: "row",
		borderWidth: 1,
		borderColor: THEME_COLORS.buttonBgColor,
		...THEME_STYLES.buttonStyle,
	},
	shadowBox: {
		shadowColor: "#000",
		shadowOffset: {
			width: 0,
			height: 4,
		},
		shadowOpacity: 0.32,
		shadowRadius: 5.46,
		elevation: 9,
	},
});
